import { Language } from 'common/types'

export const DEFAULT_LANGUAGE = Language.EN
export const LANGUAGE_COOKIE = 'hmLangCookie'

export const NAVIGATOR_LANGUAGE_MAP: {[key: string]: Language} = {
  ar: Language.AR,
  es: Language.ES,
  fr: Language.FR,
  pt: Language.PT,
  en: Language.EN
}
